export type StorageLevel = "full" | "summary" | "reference";

export const storageLevelDescriptions: Record<StorageLevel, { label: string; description: string }> = {
    full: {
        label: "Full",
        description: "Store complete document content. Best for detailed retrieval and Q&A.",
    },
    summary: {
        label: "Summary",
        description: "Store AI-generated summaries only. Reduces storage while keeping key insights.",
    },
    reference: {
        label: "Reference",
        description: "Store metadata and references only. Minimal storage, useful for file discovery.",
    },
};

export type AccessMode = "full" | "restricted";

export const accessModeDescriptions: Record<AccessMode, { label: string; description: string }> = {
    full: {
        label: "Full Read Access",
        description: "Grant read access to all files in your Google Drive. Best for comprehensive indexing.",
    },
    restricted: {
        label: "Restricted",
        description: "Select specific files to share. Only chosen files will be accessible to Tekkr.",
    },
};

export const NANGO_INTEGRATION_BY_ACCESS_MODE: Record<AccessMode, string> = {
    full: "google-drive",
    restricted: "google-drive-restricted",
};
